import React, { useState } from 'react';

// Import the real WakaTime URLs from the service
import { wakatimeService } from '../services/wakatimeService';

// WakaTime Language Stats Component - Uses real live data
export const WakaTimeLanguageStats = ({ className = '', style = {} }) => {
  const [imageLoaded, setImageLoaded] = useState(true);

  return (
    <div className={className} style={style}>
      {imageLoaded ? (
        <img
          src={wakatimeService.getLanguageStatsUrl()}
          alt="WakaTime Language Stats"
          style={{
            width: '100%',
            height: 'auto',
            borderRadius: '8px',
            background: 'transparent',
            maxWidth: '500px'
          }}
          onError={() => {
            setImageLoaded(false);
          }}
          onLoad={() => {
            console.log('WakaTime language stats loaded successfully');
          }}
        />
      ) : (
        <div style={{
          padding: '20px',
          textAlign: 'center',
          color: '#9ca3af',
          border: '1px solid rgba(255, 255, 255, 0.1)',
          borderRadius: '8px',
          background: 'rgba(0, 0, 0, 0.2)'
        }}>
          <p>📊 Language stats temporarily unavailable</p>
          <p style={{ fontSize: '0.8rem', opacity: 0.7 }}>
            Live coding statistics from WakaTime
          </p>
        </div>
      )}
    </div>
  );
};

// WakaTime Badge Component - Shows total coding time
export const WakaTimeBadge = ({ className = '', style = {} }) => {
  return (
    <a
      href={wakatimeService.getProfileUrl()}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
      style={style}
    >
      <img
        src={wakatimeService.getBadgeUrl()}
        alt="Total time coded since Mar 1 2022"
        style={{
          height: 'auto',
          borderRadius: '4px',
          ...style
        }}
        onLoad={() => {
          console.log('WakaTime badge loaded successfully');
        }}
      />
    </a>
  );
};

// WakaTime Embeddable Chart Component - Shows detailed stats
export const WakaTimeEmbeddableChart = ({ className = '', style = {} }) => {
  return (
    <div className={className} style={style}>
      <figure style={{ margin: 0 }}>
        <embed
          src={wakatimeService.getEmbeddableChartUrl()}
          style={{
            width: '100%',
            height: 'auto',
            minHeight: '200px',
            borderRadius: '8px',
            background: 'transparent',
            ...style
          }}
          onLoad={() => {
            console.log('WakaTime embeddable chart loaded successfully');
          }}
        />
      </figure>
    </div>
  );
};

// Combined WakaTime Stats Component - All real live data
export const WakaTimeStatsSection = ({
  showLanguages = true,
  showBadge = false,
  showEmbeddableChart = false,
  showTitle = true
}) => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      gap: '20px',
      width: '100%'
    }}>
      {showLanguages && (
        <div>
          {showTitle && (
            <h3 style={{
              color: '#e2e8f0',
              marginBottom: '12px',
              fontSize: '1.1rem',
              fontWeight: '600'
            }}>
              🔥 My Language Stats
            </h3>
          )}
          <WakaTimeLanguageStats />
        </div>
      )}

      {showBadge && (
        <div style={{ textAlign: 'center' }}>
          {showTitle && (
            <h3 style={{
              color: '#e2e8f0',
              marginBottom: '12px',
              fontSize: '1.1rem',
              fontWeight: '600'
            }}>
              ⏱️ Total Coding Time
            </h3>
          )}
          <WakaTimeBadge />
        </div>
      )}

      {showEmbeddableChart && (
        <div>
          {showTitle && (
            <h3 style={{
              color: '#e2e8f0',
              marginBottom: '12px',
              fontSize: '1.1rem',
              fontWeight: '600'
            }}>
              📊 Detailed Stats
            </h3>
          )}
          <WakaTimeEmbeddableChart />
        </div>
      )}
    </div>
  );
};

export default WakaTimeStatsSection;
